import { IWidgetControllerConfig } from '@wix/native-components-infra/dist/src/types/types';
import { WixOOISDKAdapter } from '@wix/bookings-adapter-ooi-wix-sdk';

export function createWixSdkAdapter(
  controllerConfig: IWidgetControllerConfig,
): WixOOISDKAdapter {
  return new WixOOISDKAdapter(
    controllerConfig.wixCodeApi as any,
    controllerConfig.platformAPIs,
    controllerConfig.appParams,
    controllerConfig.compId,
  );
}
